import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

export const getPlansSwiperConfig = (slideCount: number, swiperRef: React.MutableRefObject<any>) => {
  let config: any = {};
  switch (slideCount) {
    case 1:
      config = {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
      };
      break;
    case 2:
      config = {
        slidesPerView: 1.15,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
      };
      break;
    case 3:
      config = {
        slidesPerView: 1.15,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          991: {
            slidesPerView: 3,
            spaceBetween: 10,
            allowTouchMove: false,
          },
          767: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            allowTouchMove: true,
          },
          480: {
            slidesPerView: 1.15,
            spaceBetween: 8,
            allowTouchMove: true,
          },
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
      };
      break;
    default:
      config = {
        slidesPerView: 1.15,
        spaceBetween: 8,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          991: {
            slidesPerView: 3.15,
            spaceBetween: 10,
            slidesPerGroup: 3,
          },
          767: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            slidesPerGroup: 2,
          },
          480: {
            slidesPerView: 1.15,
            spaceBetween: 8,
            slidesPerGroup: 1,
          },
        },
        modules: [Navigation, Pagination, Scrollbar, A11y],
        onSwiper: (swiper: any) => {
          swiperRef.current = swiper;
        },
      };
      break;
  }
  return config;
};
